module.exports = __webpack_public_path__ + "static/img/footer.39f9a555.png";